import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PostaxRateService {


  url = environment.serverAPI9 + "/api/taxrates";

  constructor(private http: HttpClient) { }

  getAllTaxRate(Page: any, size: any, sort: any): Observable<Object> {
    return this.http.get(`${this.url}?page=${Page}&size=${size}&sort=${sort}`);
  }

  getAllTaxDropDown(): Observable<Object> {
    return this.http.get(`${this.url}/dropdown`);
  }


  getTaxById(id: number): Observable<Object> {
    return this.http.get(`${this.url}/${id}`);
  }

  addOrEdittaxRate(taxRate: any): Observable<Response[]> {
    return this.http.post<Response[]>(`${this.url}`, taxRate);
  }

  TaxSearch(query, Page: any, size: any, sort: any): Observable<Object> {
    return this.http.get(`${this.url}/filter?search=${query}&page=${Page}&size=${size}&sort=${sort}`);
  }
  deleteByTaxRatesId(id: any): Observable<Object> {
    return this.http.delete(`${this.url}/${id}`);
  }
  downloadTaxRatesTemplate(): Observable<any> {
    return this.http.get(`${this.url}/template/download`, { responseType: 'arraybuffer', observe: 'response' });
  }
  downloadTaxRateReport(Page: number, size: number, sort, selectionTaxRate): Observable<any> {
    return this.http.post(`${this.url}/export/page?page=${Page}
		&size=${size}&sort=${sort}`, selectionTaxRate, {
      responseType: 'arraybuffer',
      observe: 'response'
    });
  }
}
